// import Sidebar from "../Sidebar/Sidebar";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";

import DashboardContent from "./DashboardContent/dashboardContent";

const LayoutPage = () => {
    const design = (
            <>
                <div class="flex min-h-screen">
                {/* <Sidebar />  */}
                {/* <AnalysisSidebar /> */}
                <div class="flex-1 ">
                    <Header />
                    <Outlet />
                    {/* <DashboardContent /> */}

                </div>
            </div>
            <Footer />

            </>
    )
    return design;
}

export default LayoutPage;